<template>
  <div v-parallax-fit="parallax" class="plane">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/28_Plane.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 22800,
          end: 23400,
          fromStyle: { transform: 'translateX(-200%) translateY(0%) rotate(50deg) scale(0)', },
          toStyle: { transform: 'translateX(-50%) translateY(180%) rotate(30deg) scale(1.2)', },
          easing: 'linear'
        },
        {
          start: 23450,
          end: 24000,
          fromStyle: { transform: 'translateX(-50%) translateY(180%) rotate(30deg) scale(1.2)', },
          toStyle: { transform: 'translateX(200%) translateY(0%) rotate(-50deg) scale(1.2)', },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateX(-50%) translateY(180%) rotate(30deg) scale(1.2)') {
          self.$evidence.value = null;
          self.$readMore.value = '';
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.plane'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.plane {
  position: absolute;
  bottom: 100%;
  left: 50%;
  max-width: 500px;
  transition: all 0.1s linear;
  z-index: 3;
}
</style>
